<template>
  <Head title="Avid - Password Reset Start" />
  
  <div class="container-fluid d-flex flex-column h-100 onboarding-container">
    <div class="row m-4 justify-content-center onboarding-new align-items-stretch">
        <div class="col-lg-9 col-12">
            <div class="row h-100 justify-content-center align-items-center flex-grow-1">
                <div class="container-fluid col-12">
                    <Link class="navbar-brand" href="/">
                        <img src="/img/logo_png/avid_logo_black.png" alt="Avid" class="navbar-brand-logo-avidonly px-2">
                    </Link>
                </div>
                <div class="registration-form-container col-lg-5 col-12 mt-5 mt-lg-0 d-flex flex-column justify-content-center align-items-stretch">
                    <Link href="/" class="d-block w-100 text-center">
                        <img src="/img/logo_png/logo_tile.png" alt="Avid" class="mb-3" style="width: 50px; height: 50px;">
                    </Link>
                    <h2 class="text-center mb-4">Reset Password</h2>
                    <div class="row">
                        <div v-if="status" class="alert alert-success" role="alert">
                            {{ status }}
                        </div>

                        <form method="POST" action="/password/email" class="w-100">
                            <input type="hidden" name="_token" :value="csrfToken">

                            <div class="mb-3">
                                <input 
                                    id="email" 
                                    type="email" 
                                    placeholder="Email" 
                                    class="form-control" 
                                    :class="{ 'is-invalid': errors.email }" 
                                    name="email" 
                                    v-model="form.email" 
                                    required 
                                    autocomplete="email" aria-label="Email">
                                <span v-if="errors.email" class="invalid-feedback" role="alert">
                                    <strong>{{ errors.email }}</strong>
                                </span>
                            </div>

                            <button type="submit" class="btn btn-primary w-100">
                                Send Password Reset Link
                            </button>
                        </form>

                        <p class="mt-4">No account yet?
                            <Link class="btn btn-link ps-0" href="/register">
                                Sign Up
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-3 d-none d-lg-block bg-with-image"></div>
    </div>
  </div>
</template>

<script setup>
import { Head, Link } from '@inertiajs/vue3';
import { computed, reactive } from 'vue';

const props = defineProps({
  status: {
    type: String,
    default: null
  },
  errors: {
    type: Object,
    default: () => ({})
  }
});

const csrfToken = computed(() => document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'));

const form = reactive({
  email: ''
});
</script>

